import { CardCompany } from 'types/card';

export const theme = {
  [CardCompany.Shinhan]: '#0046FF',
  [CardCompany.Hana]: '#028375',
  [CardCompany.Woori]: '#0167AC',
  [CardCompany.Kb]: '#FBAF15',
  [CardCompany.Lotte]: '#E21C23',
  [CardCompany.Nh]: '#22A54A',
  [CardCompany.Samsung]: '#1428A0',
  [CardCompany.Hyundai]: '#1E191A',
};
